(function () {
  'use strict';

  angular
      .module('tf.retailer.Analytics')
      .directive('infoIcon', infoIcon);

  // @ngInject
  function infoIcon() {
    return {
      restrict : 'E',
      templateUrl : 'Analytics/infoIcon.tmpl.html',
      scope : {
        // todo: this will be a key that will indicate which text to show
        info : '@',
        placement : '@'
      }
    };
  }

})();
